/**
 * themes.js
 */

import { Types } from 'utils/constants';
import defaultLight from './default/light';
import defaultDark from './default/dark';


export default {
  [Types.Theme.LIGHT]: defaultLight,
  [Types.Theme.DARK]: defaultDark,
};